import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HomePageHeader from "../../components/HomePageHeader";
import HomePageSearchBar from "../../components/HomePageSearchBar";
import HomePageFooter from "../../components/HomePageFooter";
import ProductFilterBar from "../../components/ProductFilterBar";
import ProductPageListCard from "../../components/ProductPageListCard";
import styles from "./productspage.module.css";


export default function ProductsPage() {
  const location = useLocation();

  useEffect(() => {
    function userdata() {
      const userData = location.state;
      if (userData) {
        console.log("User data:", userData);
      } else {
        console.log("No user data found");
      }
    }
    userdata();
  }, [location.state]);

  return (
    <div className={styles.productpage}>
      <HomePageHeader />
      <HomePageSearchBar />
      <div className="row">
        <div className="col-md-3">
          <ProductFilterBar />
        </div>
        <div className="col-md-9">
          <ProductPageListCard />
        </div>
      </div>
      <HomePageFooter />
    </div>
  )
};
